<template>
    <div class="dingtalk-bind-container">
      <h2>绑定资源学习平台账号</h2>
      <el-form :model="bindForm" ref="bindFormRef" label-width="100px">
        <el-form-item label="学习平台账号" prop="username">
          <el-input v-model="bindForm.username" placeholder="请输入系统的用户工号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitBindForm()">提交绑定</el-button>
        </el-form-item>
      </el-form>
      <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
      <div v-if="successMessage" class="success-message">{{ successMessage }}</div>
    </div>
  </template>
  
  <script>
  import { dingTalkBindUser} from '@/api/api'
  export default {
    data() {
      return {
        bindForm: {
          username: '',
        },
        bindFormRef: null,
        errorMessage: '',
        successMessage: '',
        dingtalkId:''
      };
    },
    created() {
        this.dingtalkId = this.$route.params.dingtalkId;
    },
    methods: {
      async submitBindForm() {
        //这里可以做用户名校验以及密码验证之类的，后期再说

        dingTalkBindUser({
            userName: this.bindForm.username,
            dingtalkId: this.dingtalkId
        }).then(response => {
            if (response.code === 0) {
                this.successMessage = '绑定成功！正在跳转至主页...';
                this.errorMessage = '';
                setTimeout(() => {
                    this.$router.push({ path: '/home' })
                }, 2000);
            } else {
            throw new Error(response.data.msg);
            }

        }).catch(error => {
          this.$message.error('绑定失败');
        }); 

      },
    },
  };
  </script>
  
  <style scoped lang="scss">
  .dingtalk-bind-container {
    padding: 20px;
    max-width: 400px;
    margin: 0 auto;
  
    h2 {
      text-align: center;
      margin-bottom: 20px;
    }
  
    .error-message {
      color: red;
      margin-top: 10px;
    }
  
    .success-message {
      color: green;
      margin-top: 10px;
    }
  }
  </style>    


// WEBPACK FOOTER //
// src/views/DingTalkBind.vue